import { render, staticRenderFns } from "./UserChanger.vue?vue&type=template&id=1a49f886&scoped=true"
import script from "./UserChanger.vue?vue&type=script&lang=js"
export * from "./UserChanger.vue?vue&type=script&lang=js"
import style0 from "./UserChanger.vue?vue&type=style&index=0&id=1a49f886&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a49f886",
  null
  
)

export default component.exports